import { COLORS } from '@elo-kit/constants/general.constants'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlue, eloWhite } = COLORS

// TODO: update with using createUseStyles
const lessonsNavigationStyles = (theme) => {
  const bannerFont = cleanupFonts(theme.lesson.bannerFont)
  return {
    pageNavigation: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      paddingTop: '40px',
      fontFamily: bannerFont || 'Montserrat Reg',
      color: '#9e9e9e',
      '& i': {
        padding: '0 20px',
      },
    },
    pageNavigationActiveItem: {
      color: theme.linkColor || eloBlue,
      cursor: 'pointer',
    },
    lessonsNavigation: {
      display: 'flex',
      padding: '20px 0',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      '& button': {
        margin: '10px 0',

        '& .fa-flag-checkered': {
          paddingRight: '10px',
        },
      },
      '@media (max-width: 991px)': {
        padding: '20px 10px',
      },
    },
    noPaddings: {
      '@media (max-width: 991px)': {
        padding: '20px 0px',
      },
    },
    buttonContainer: {
      display: 'flex',

      '@media (max-width: 576px)': {
        width: '100%',
      },

      '& button:first-child': {
        marginRight: '20px',

        '@media (max-width: 991px)': {
          marginRight: 0,
        },
      },
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',
      minWidth: '100px',
      minHeight: '48px',
      borderRadius: '6px',
      backgroundColor: theme.buttonColor || eloBlue,
      fontSize: '14px',
      fontFamily: bannerFont || 'Montserrat Medium',
      color: eloWhite,
      border: 'none',
      padding: '0 20px',
      cursor: 'pointer',
      '& .fa-chevron-left': {
        paddingRight: '10px',
      },
      '& .fa-chevron-right': {
        paddingLeft: '10px',
      },
      '&:hover': {
        opacity: 0.8,
      },
      '&:active': {
        opacity: 0.6,
      },
    },
    outlineButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',
      minWidth: '100px',
      minHeight: '48px',
      borderRadius: '6px',
      border: `solid 2px ${theme.buttonColor || eloBlue}`,
      background: 'none',
      fontSize: '14px',
      fontFamily: bannerFont || 'Montserrat Medium',
      color: theme.buttonColor || eloBlue,
      padding: '0 20px',
      cursor: 'pointer',
      '& .fa-chevron-left': {
        paddingRight: '10px',
      },
      '& .fa-chevron-right': {
        paddingLeft: '10px',
      },
      '&:hover': {
        opacity: 0.8,
      },
      '&:active': {
        opacity: 0.6,
      },
    },
    buttonDisabled: {
      visibility: 'hidden',
    },
    finishButton: {
      '@media (max-width: 576px)': {
        width: '100%',
      },
    },
  }
}

export default lessonsNavigationStyles
